import { Chip, useTheme } from "@mui/material";
import { tokens } from "../theme/tokens";

const StatusChip = ({ label, tone = "default", size = "small", sx = {} }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const chip = colors.chip?.[tone] || colors.chip?.default || {
    bg: "rgba(255,255,255,0.08)",
    color: colors.text.primary,
    border: colors.surface.border,
  };

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        bgcolor: chip.bg,
        color: chip.color,
        border: `1px solid ${chip.border}`,
        fontWeight: 600,
        borderRadius: 999,
        height: 24,
        "& .MuiChip-label": {
          px: 1,
        },
        ...sx,
      }}
    />
  );
};

export default StatusChip;